module.exports = __webpack_public_path__ + "img/type-service.5226fc2d.png";